export default __webpack_public_path__ + "static/media/0x0000000000000000000000000000000000000000.7bd1c8d6.svg";